import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const TestPrepSection = () => {
  const sectionRefIELTS = useRef(null);

  // Animation for the heading lines
  useGSAP(() => {
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);

    // GSAP scroll-triggered animation for .line elements
    gsap.from(sectionRefIELTS.current, {
      y: 100, // Initial Y offset
      opacity: 0, // Start with opacity 0
      duration: 1.5, // Duration of the animation
      stagger: 0.1, // Stagger delay between elements
      ease: "power3.out", // Easing for smoothness
      scrollTrigger: {
        trigger: "#IELTS-section", // Trigger animation when this element comes into view
        start: "top 80%", // Start when top of the section is at 80% of viewport height
      },
    });
  }, []);

  return (
    <section id="IELTS-section" className="bg-[#cac8bb]">
      <div className="container w-[80%] mx-auto flex justify-between items-center">
        {/* Left Content */}

        <div className="p-6 rounded-lg mt-28 mr-32 w-[40%]">
          <div className="relative w-full h-screen overflow-hidden rounded-lg">
            <div className="absolute inset-0 mt-32">
              <img
                src="/Assets/x1.png"
                className="w-[900px] h-auto"
                alt="SocraticAli Consultant"
              />
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="animate-lines mb-8 mt-40 overflow-hidden w-[60%]">
          <h1
            ref={sectionRefIELTS}
            className="text-[90px] font-bold text-white leading-[1] tracking-tighter"
          >
            <div className="">ACE IELTS & PTE WITH</div>
            <div className="">
              <span className="text-[#457b9d]">SOCRACTICALI</span>
            </div>
          </h1>
          <p className="text-black text-[24px] mt-4 tracking-tight">
            Join a results-driven learning space built for ambitious students
            aiming to study abroad. Socraticali's expert-led IELTS and PTE
            programs are tailored to help you secure the scores you need for top
            international universities.
            <br />
            <br />
            Whether you're preparing for the UK, Australia, Canada, or
            beyond—we've got your back with strategies, mock tests, and
            one-on-one guidance. Start your journey with Socraticali today and
            turn your study-abroad dream into a real plan.
          </p>
          <a
            href="https://forms.gle/DEeZaDUNzDewSqNbA"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-[#457b9d] w-[50%] text-center text-white text-[16px] font-bold px-10 py-3 rounded-md mt-10 hover:bg-[#1d3557] hover:text-white transition-all duration-300"
          >
            JOIN OUR TEST PREP PROGRAM
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestPrepSection;
